<div class="fixed-bottom w-100 modal-cmmnt-bg border-top pt-1 pb-1 fnt-size12px" style="min-height: 50px; z-index: 12;">
        <div class="d-block text-center">
        <div class="d-inline-block w-20 pl-2 pr-2"><div class="elips-content">
                <p><svg class="mr-1" viewBox="0 0 16 16" width="20px"><defs  class="ng-tns-c8-0"><style  class="ng-tns-c8-0">.home-res{fill:#767577;}</style></defs><g  class="ng-tns-c8-0" data-name="Layer 3" id="Layer_3"><path  class="home-res" d="M15.21,7.2,8.59,1.26a.89.89,0,0,0-1.18,0L.79,7.2a.88.88,0,0,0-.23,1,.87.87,0,0,0,.84.56h.16v5.36a.89.89,0,0,0,.88.88H13.55a.88.88,0,0,0,.87-.88V8.73h.18a.91.91,0,0,0,.84-.56A.88.88,0,0,0,15.21,7.2ZM10,11.52H6A.57.57,0,0,1,5.43,11,.58.58,0,0,1,6,10.39h4a.58.58,0,0,1,.57.57A.57.57,0,0,1,10,11.52Z"></path></g></svg><br/> 
                    {{mls?.languageText?.mob_button_menu?.key1}}<span *ngIf="mls?.is_lskey_display == 1">(mob_button_menu.key1)</span> 
                </p></div>
            </div>
        <div class="d-inline-block w-20 pl-2 pr-2"><div class="elips-content">
                <p>
                    {{mls?.languageText?.mob_button_menu?.key2}}<span *ngIf="mls?.is_lskey_display == 1">(mob_button_menu.key2)</span> 
               
                </p>
            </div>
        </div>
        <div class="d-inline-block w-20 pl-2 pr-2"><div class="elips-content">
                <p><img src="assets/images/profile-explore/explore.svg" width="20px"><br/>
                    {{mls?.languageText?.mob_button_menu?.key3}}<span *ngIf="mls?.is_lskey_display == 1">(mob_button_menu.key3)</span> 
                </p></div></div>
        <div class="d-inline-block w-20 pl-2 pr-2">
            <div class="elips-content">
            <p><img src="assets/images/grandround/connection-responsive.svg" width="20px"><br/>
                {{mls?.languageText?.mob_button_menu?.key4}}<span *ngIf="mls?.is_lskey_display == 1">(mob_button_menu.key4)</span> 
            </p></div>
        </div>
        <div class="d-inline-block w-20 pl-2 pr-2">
                <div class="elips-content">
            <p><img src="assets/images/grandround/profile_sub.svg" width="20px"/><br/> 
                {{mls?.languageText?.mob_button_menu?.key5}}<span *ngIf="mls?.is_lskey_display == 1">(mob_button_menu.key5)</span> 
            </p>
            </div>
        </div>
        </div>
        </div>